import {useReducer} from 'react';
import {DialogTitle} from '@headlessui/react';
import {CheckIcon} from '@heroicons/react/24/outline';
import {Modal} from 'components';

interface IModalBillingSuccessProps {
  sessionId: string;
}

const ModalBillingSuccess = ({}: IModalBillingSuccessProps) => {
  const [visible, toggleVisible] = useReducer(s => !s, true);
  return (
    <Modal visible={visible} onClose={toggleVisible}>
      <div>
        <div className="mx-auto flex size-12 items-center justify-center rounded-full bg-green-100">
          <CheckIcon aria-hidden="true" className="size-6 text-green-600" />
        </div>
        <div className="mt-3 text-center sm:mt-5">
          <DialogTitle as="h3" className="text-base font-semibold text-gray-900 dark:text-white">
            Payment successful
          </DialogTitle>
          <div className="mt-2">
            <p className="text-sm text-gray-500 dark:text-darkText">You have subscribed to a plan. Thank you for the subscription.</p>
          </div>
        </div>
      </div>
      <div className="mt-5 sm:mt-6">
        <button
          type="button"
          onClick={toggleVisible}
          className="inline-flex w-full justify-center rounded-md bg-primary px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 cursor-pointer">
          Continue
        </button>
      </div>
    </Modal>
  );
};

export default ModalBillingSuccess;
